import React from "react";
import nopage from "../../Assets/seoimg/nopage.png";

import { useTranslation } from "react-i18next";

const NoPage = () => {
  const { t } = useTranslation();

  return (
    <div className="cmc text-center" style={{ height: "100vh" }}>
      <div>
        <img height={300} src={nopage}></img>
        <div style={{ position: "relative" }}>
          <h1
            data-title={t("page_not_found.description")}
            type="button"
            style={{ color: "#3F3D56" }}
          >
            {" "}
            <i>{t("page_not_found.title")} </i>
          </h1>
        </div>
      </div>
    </div>
  );
};

export default NoPage;
